import React from 'react';
import { DoneIconBig } from 'components/common/icons';
import { Col, FMGModal, Row, Typography } from 'components';
import { SupplierOfferSourceValueType } from 'models/SupplierOffer';
import { usePublishCalculationModal } from './usePublishCalculationModal';

interface PublishSupplierOfferModal {
  openModal: boolean;
  recordId: string | undefined;
  onClose: () => void;
  source?: SupplierOfferSourceValueType;
  entityId?: string;
}

export const PublishSupplierOfferModal = (props: PublishSupplierOfferModal) => {
  const { openModal, onClose, recordId, entityId, source } = props;
  const { onConfirm } = usePublishCalculationModal(onClose, source, entityId);
  return (
    <FMGModal
      width={360}
      onCancel={onClose}
      open={openModal}
      onSubmit={() => onConfirm(recordId)}
      onClose={onClose}
      okText={'Publish'}
    >
      <Row justify="center" gutter={[0, 12]} className={'margin-t-20'}>
        <Col span={24} className={'center'}>
          <DoneIconBig />
        </Col>
        <Col span={24} className={'center'}>
          <Typography.Title className={'reset-title'} level={3}>
            Publish Calculation
          </Typography.Title>
        </Col>
        <Col span={24} className={'center'}>
          <Typography.Text>Are you sure you want to publish calculation?</Typography.Text>
        </Col>
      </Row>
    </FMGModal>
  );
};
